import {
	Component,
	Injector,
} from '@angular/core';

import {
	NgForm,
	UntypedFormControl,
} from '@angular/forms';

import { finalize } from 'rxjs/operators';
import { UIRouter } from '@uirouter/angular';

import { CommonBaseComponent } from '../../../Common/components/base.component';
import { CommonAppDataService } from '../../../Common/services/app_data/app_data.service';
import { CommonNotificationService } from '../../../Common/services/notification.service';
import { commonUtilitiesCoreService } from '../../../Common/services/core.service';

import { AuthenticationMeetingsUserService, IAuthenticationMeetingsUserActionsResponse } from '../authentication/services/authentication.meetings.user.service';
import { AuthenticationMeetingsErrorService } from '../authentication/services/authentication.meetings.error.service';
import { MeetingsAuthAnimation } from '../animation/animation';
import { IAuthenticationMeetingsChangePassword } from '../authentication/authentication.interfaces';

@Component({
	selector: 'authentication-meetings-change-password',
	templateUrl: './authentication.meetings.change_password.component.pug',
	animations: [
		MeetingsAuthAnimation,
	],
})
export class AuthenticationMeetingsChangePasswordComponent extends CommonBaseComponent {
	state = {
		isSaving: false,
	};

	data: IAuthenticationMeetingsChangePassword = {
		Code: commonUtilitiesCoreService.getQueryStringKeyValue('code'),
		Password: '',
		ConfirmPassword: '',
	};

	pageStateError = this.commonAppDataService.getDataByPath('pageStateError');

	resource = {
		validationCustomErrors: {
			custom: '',
			passwordsMatch: this.instant('meetings_auth.forms.change_password.controls.new_password.messages.match'),
			minLength: this.instant('meetings_auth.forms.change_password.controls.password.messages.minlength'),
		},
	};

	onChangeFieldHandler = this.authenticationMeetingsErrorService.onChangeFieldHandler;

	constructor (
		protected injector: Injector,
		private authenticationMeetingsUserService: AuthenticationMeetingsUserService,
		private router: UIRouter,
		private authenticationMeetingsErrorService: AuthenticationMeetingsErrorService,
		private commonAppDataService: CommonAppDataService,
		private commonNotificationService: CommonNotificationService,
	) {
		super(injector);
	}

	changePassword (form: NgForm) {
		if (form.valid) {
			this.state.isSaving = true;

			this.authenticationMeetingsUserService
				.changePassword(this.data)
				.pipe(
					finalize(() => this.state.isSaving = false),
				)
				.subscribe((response: IAuthenticationMeetingsUserActionsResponse) => {
					if (response.IsSuccess) {
						this.router.stateService.go('login')
							.then(() => {
								this.commonNotificationService.show(
									this.instant('meetings_auth.forms.login.password_notification.title'),
									this.instant('meetings_auth.forms.login.password_notification.description'),
									'info',
								);
							});
					} else {
						this.authenticationMeetingsErrorService.handleSuccessResponse(response, this.resource.validationCustomErrors, form.controls.confirmPassword as UntypedFormControl);
					}
				});
		}
	}
}
